var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDiners = function SvgDiners(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 68,
    viewBox: "0 0 105 68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M77.344 28.333L77.344 0 0 0 0 28.333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 68,
    fill: "#FFF",
    rx: 11.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.011 36.833)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102.188,
    height: 65.188,
    x: 1.406,
    y: 1.406,
    stroke: "#979797",
    strokeWidth: 2.813,
    rx: 5.625
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "M33.888 45.909c12.525.06 23.957-10.233 23.957-22.755C57.845 9.46 46.413-.005 33.888 0h-10.78C10.433-.005 0 9.463 0 23.154c0 12.525 10.433 22.815 23.108 22.755h10.78z",
    transform: "translate(23 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.16 1.897C11.576 1.901 2.19 11.306 2.188 22.914c.002 11.605 9.388 21.01 20.97 21.013 11.585-.004 20.973-9.408 20.974-21.013C44.132 11.306 34.744 1.9 23.16 1.897zM9.866 22.914c.01-5.673 3.547-10.51 8.533-12.431v24.859c-4.986-1.921-8.523-6.756-8.533-12.428zm18.05 12.433V10.482c4.988 1.917 8.53 6.757 8.538 12.432-.009 5.676-3.55 10.512-8.538 12.433z",
    transform: "translate(23 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "M33.888 45.909c12.525.06 23.957-10.233 23.957-22.755C57.845 9.46 46.413-.005 33.888 0h-10.78C10.433-.005 0 9.463 0 23.154c0 12.525 10.433 22.815 23.108 22.755h10.78z",
    transform: "translate(23 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.16 1.897C11.576 1.901 2.19 11.306 2.188 22.914c.002 11.605 9.388 21.01 20.97 21.013 11.585-.004 20.973-9.408 20.974-21.013C44.132 11.306 34.744 1.9 23.16 1.897zM9.866 22.914c.01-5.673 3.547-10.51 8.533-12.431v24.859c-4.986-1.921-8.523-6.756-8.533-12.428zm18.05 12.433V10.482c4.988 1.917 8.53 6.757 8.538 12.432-.009 5.676-3.55 10.512-8.538 12.433z",
    transform: "translate(23 12)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiners, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diners.84b47d17.svg";
export { ForwardRef as ReactComponent };